module.exports = __webpack_public_path__ + "img/marker_six_cyan1.f6de9de3.png";